import React, { Component } from 'react';
import MenuList from "../sections/MenuList";
import logo from '../../assets/header/logo.svg'
import menuIcon from '../../assets/header/menu.svg';

class Header extends Component {
    render() {
        const { t, menuOpen, width, handleMenuToggle, language } = this.props;
       
        return (
            <div className="landing-container-header">
                <div className="landing-layout">
                    <div className="landing-page-header">
                        <div className="landing-header-logo">
                            <img src={logo} alt="logo" />
                        </div>
                        {
                            width !== 'phone' &&
                            <MenuList t={t} menuOpen={menuOpen} handleMenuToggle={handleMenuToggle} language={language} />

                        }
                        {
                            (width === 'phone') &&
                            <img
                                className="landing-hamburger-mobile"
                                src={menuIcon} alt="logo"
                                onClick={e => handleMenuToggle(e)}
                                onKeyPress={e => handleMenuToggle(e)}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default Header;
